function matchHeight(selector) {
  const elements = document.querySelectorAll(selector);
  if (!elements.length) return;

  elements.forEach(el => {
    el.style.height = 'auto';
  });

  requestAnimationFrame(() => {
    let maxHeight = 0;

    elements.forEach(el => {
      const height = el.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    elements.forEach(el => {
      el.style.height = `${maxHeight}px`;
    });
  });
}

function initMatchHeight() {
  matchHeight('.card__information--meta');
  matchHeight('.card__information--meta .card__heading');
}

document.addEventListener('DOMContentLoaded', initMatchHeight);
window.addEventListener('load', initMatchHeight);
window.addEventListener('resize', () => {
  clearTimeout(window._mhTimer);
  window._mhTimer = setTimeout(initMatchHeight, 100);
});

document.addEventListener('DOMContentLoaded', () => {
  const megaMenus = document.querySelectorAll('.mega-menu__content');
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  megaMenus.forEach(menu => {
    const links = menu.querySelectorAll('[data-link]');
    const shopAllLinks = menu.querySelectorAll('.menu__shop--all');
    const productWraps = menu.querySelectorAll('.megamenu__list--right-products-wrap');
    const rightImages = menu.querySelector('.megamenu__list--right-images');
    const productBlocks = menu.querySelectorAll('.megamenu__list--right-products');
    const firstLink = links.length ? links[0] : null;
    const firstProductBlock = productBlocks.length ? productBlocks[0] : null;

    if (firstLink) firstLink.classList.add('active');
    if (firstProductBlock) firstProductBlock.classList.add('active');
    if (productWraps.length) productWraps.forEach(wrap => (wrap.style.display = 'flex'));
    if (rightImages) rightImages.style.display = 'none';

    const interactionEvent = isTouchDevice ? 'click' : 'mouseenter';

    const activateLink = (link, isShopAll = false) => {
      const target = link.getAttribute('data-link');
      let matchFound = false;

      links.forEach(l => l.classList.remove('active'));
      shopAllLinks.forEach(l => l.classList.remove('active'));
      productBlocks.forEach(block => block.classList.remove('active'));

      link.classList.add('active');

      if (isShopAll) {
        if (rightImages) rightImages.style.display = 'flex';
        productWraps.forEach(wrap => (wrap.style.display = 'none'));
        return;
      }

      productBlocks.forEach(block => {
        if (block.getAttribute('data-collection') === target) {
          block.classList.add('active');
          matchFound = true;
        }
      });

      productWraps.forEach(wrap => (wrap.style.display = matchFound ? 'flex' : 'none'));
      if (rightImages) rightImages.style.display = matchFound ? 'none' : 'flex';

      if (!matchFound && firstProductBlock) {
        firstProductBlock.classList.add('active');
      }
    };

    links.forEach(link => {
      link.addEventListener(interactionEvent, e => {
        if (isTouchDevice) e.preventDefault();
        activateLink(link);
      });
    });

    shopAllLinks.forEach(link => {
      link.addEventListener(interactionEvent, e => {
        if (isTouchDevice) e.preventDefault();
        activateLink(link, true);
      });
    });

    if (!isTouchDevice) {
      menu.addEventListener('mouseleave', () => {
        links.forEach(l => l.classList.remove('active'));
        shopAllLinks.forEach(l => l.classList.remove('active'));
        productBlocks.forEach(block => block.classList.remove('active'));

        if (firstLink) firstLink.classList.add('active');
        if (firstProductBlock) firstProductBlock.classList.add('active');

        productWraps.forEach(wrap => (wrap.style.display = 'flex'));
        if (rightImages) rightImages.style.display = 'none';
      });
    }
  });
});

(function() {
  function formatPrice(priceInCents) {
    return `$${(priceInCents / 100).toFixed(2)}`;
  }

  function initProductFilters() {
    const filterContainers = document.querySelectorAll('.product__add--filter');

    filterContainers.forEach(filterContainer => {
      // Remove old listeners by cloning (clean slate)
      const optionValues = filterContainer.querySelectorAll('.option-value');
      
      optionValues.forEach(oldValueEl => {
        // Skip if already has our listener
        if (oldValueEl.hasAttribute('data-listener-attached')) return;
        oldValueEl.setAttribute('data-listener-attached', 'true');

        const variantDataEl = filterContainer.querySelector('script[type="application/json"]');
        let variants = [];
        
        if (variantDataEl) {
          try {
            variants = JSON.parse(variantDataEl.textContent);
          } catch (e) {
            console.error('Failed to parse variant data:', e);
          }
        }

        if (!filterContainer.currentVariant) {
          filterContainer.currentVariant = variants[0] || null;
        }

        function getSelectedVariant() {
          const selectedOptions = {};
          filterContainer.querySelectorAll('.option-value.active').forEach(activeOption => {
            const optionIndex = activeOption.getAttribute('data-option-index') || '1';
            selectedOptions[`option${optionIndex}`] = activeOption.getAttribute('data-value');
          });

          return variants.find(variant => 
            Object.keys(selectedOptions).every(key => variant[key] === selectedOptions[key])
          );
        }

        function updatePrices(variant) {
          if (!variant) return;
          window.currentVariant = variant;
          const onetimePriceEl = filterContainer.querySelector('.rc-option__price[data-price-onetime]');
          const subscriptionPriceEl = filterContainer.querySelector('.rc-option__price[data-price-subsave]');
          const subPrice = variant.selling_plan_allocations?.[0]?.price || variant.price;
          if (onetimePriceEl) {
            onetimePriceEl.setAttribute('data-price-onetime', variant.price);
            onetimePriceEl.textContent = formatPrice(variant.price);
          }
          if (subscriptionPriceEl) {
            subscriptionPriceEl.setAttribute('data-price-subsave', subPrice);
            subscriptionPriceEl.textContent = formatPrice(subPrice);
          }

          if(filterContainer.querySelector(".rc_widget__option__plans__dropdown")) {
            filterContainer.querySelector(".rc_widget__option__plans__dropdown").addEventListener("change", function() {
              if (onetimePriceEl) {
                onetimePriceEl.setAttribute('data-price-onetime', variant.price);
                onetimePriceEl.textContent = formatPrice(variant.price);
              }
              if (subscriptionPriceEl) {
                subscriptionPriceEl.setAttribute('data-price-subsave', subPrice);
                subscriptionPriceEl.textContent = formatPrice(subPrice);
              }
            })
          }
          console.log('Prices updated:', {
            oneTime: formatPrice(variant.price),
            subscription: formatPrice(subPrice)
          });
          const filterSku = filterContainer.querySelector('.replcement__filter-sku');
          if (filterSku && variant.sku) {
            const sanitizedSku = variant.sku.replace(/[-#=].*$/, '').trim();
            filterSku.textContent = sanitizedSku;
          }
        }

        oldValueEl.addEventListener('click', function() {
          const container = this.closest('.product__add--filter-product-option');
          container.querySelectorAll('.option-value').forEach(v => v.classList.remove('active'));
          this.classList.add('active');

          const matchedVariant = getSelectedVariant();
          if (matchedVariant) {
            filterContainer.currentVariant = matchedVariant;
            updatePrices(matchedVariant);

            const variantInput = filterContainer.querySelector('[name="id"]');
            if (variantInput) variantInput.value = matchedVariant.id;
          }
        });
      });

      // Handle select elements
      const selectElements = filterContainer.querySelectorAll('[data-plans-container] select');
      selectElements.forEach(selectEl => {
        if (selectEl.hasAttribute('data-listener-attached')) return;
        selectEl.setAttribute('data-listener-attached', 'true');

        selectEl.addEventListener('change', () => {
          const currentVariant = filterContainer.currentVariant;
          if (currentVariant) {
            // Re-run updatePrices logic
            const onetimePriceEl = filterContainer.querySelector('.rc-option__price[data-price-onetime]');
            const subscriptionPriceEl = filterContainer.querySelector('.rc-option__price[data-price-subsave]');
            const subPrice = currentVariant.selling_plan_allocations?.[0]?.price || currentVariant.price;

            if (onetimePriceEl) {
              onetimePriceEl.setAttribute('data-price-onetime', currentVariant.price);
              onetimePriceEl.textContent = formatPrice(currentVariant.price);
            }
            if (subscriptionPriceEl) {
              subscriptionPriceEl.setAttribute('data-price-subsave', subPrice);
              subscriptionPriceEl.textContent = formatPrice(subPrice);
            }
          }
        });
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductFilters);
  } else {
    initProductFilters();
  }

  // Watch for AJAX changes - observe a stable parent container
  const cartPageContainer = document.querySelector('body'); // Or more specific like '#cart-container'
  
  if (cartPageContainer) {
    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              if (node.classList?.contains('product__add--filter') || 
                  node.querySelector?.('.product__add--filter')) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        console.log('Reinitializing product filters after AJAX...');
        setTimeout(initProductFilters, 100); // Small delay to ensure DOM is ready
      }
    });

    observer.observe(cartPageContainer, {
      childList: true,
      subtree: true
    });
  }

  // Also expose globally so you can call it manually if needed
  window.initProductFilters = initProductFilters;

})();

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.custom-count-option');

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = btn.dataset.value;
      const customOptionsContainer = btn.closest('.custom-count-options');
      const variantSelectsId = customOptionsContainer.dataset.variantSelector;

      if (!variantSelectsId) return;

      const variantSelects = document.getElementById(variantSelectsId);
      if (!variantSelects) return;
      const originalOption = variantSelects.querySelector(`[value="${value}"]`);
      if (originalOption) {
        originalOption.click();
      }
      buttons.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // document.addEventListener('click', function(event) {
  //     const button = event.target.closest('#pf_c_category .boost-sd__filter-option-item-button');
      
  //     if (button) {
  //         // Stop the event from propagating further if needed
  //         event.preventDefault(); 
          
  //         // Using setTimeout to ensure the URL is updated before refreshing the page
  //         setTimeout(function (e) {
  //             window.location.reload();
  //         }, 200);
  //     }
  // });
    
});

document.body.addEventListener("click", async function(e) {
  const btn = e.target.closest("button[custom-buy-now-button]");
  if (!btn) return;

  const form = btn.closest("form");
  if (!form) return;

  const variantId = form.querySelector("[name='id']")?.value;
  if (!variantId) return;

  const quantity = parseInt(form.querySelector("[name='quantity']")?.value || 1);
  const sellingPlanId = form.querySelector("[name='selling_plan']")?.value;

  try {
    // 🧹 Step 1: Clear the current cart
    await fetch('/cart/clear.js', { method: 'POST' });

    // 🛒 Step 2: Add the selected product
    const addPayload = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
        }
      ]
    };

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addPayload)
    });

    if (!addResponse.ok) throw new Error('Failed to add product');
    const addedData = await addResponse.json();

    window.location.href = '/checkout';
  } catch (err) {
    console.error('Buy Now failed:', err);
  }
});


